import React, { useContext, useEffect, useState } from 'react';
import styles from './RolesAndPermissions.module.scss';
import { Header, PageContainer, Sidebar, SideMenu, Page, PageAuth, PageHeader, GlobalAlert, PERMISSIONS } from '../..';
import { adminPages, useStore } from '../../../common';
import { getRows } from './RowProvider';
import { Table, Search } from 'esa-ui-library';
import { PropertyType } from 'esa-ui-library/lib/types';
import { AuthContext } from '../../../logic';

const RolesAndPermissions = (): JSX.Element => {
	const [state, dispatch] = useStore();
	const { roles, rows, columns } = state;
	const [displayRoles, setDisplayRoles] = useState<PropertyType[]>([]);
	const { token } = useContext(AuthContext);

	useEffect(() => {
		dispatch('ROLES_INIT', { token });
	}, []);

	useEffect(() => {
		setDisplayRoles(roles);
	}, [roles]);

	useEffect(() => {
		dispatch('UPDATE_ROWS', getRows(displayRoles));
	}, [displayRoles]);

	return (
		<>
			<Header dataId='header' />
			<PageAuth onlyAdmin permission={PERMISSIONS.canViewUser}>
				<PageContainer>
					<Sidebar dataId='admin-sidebar'>
						<SideMenu options={adminPages} title='Admin' />
					</Sidebar>
					<Page>
						<PageHeader title={'Roles & Permissions'} />
						<section className={styles.PageContent}>
							<Search data={roles} searchProperty={'name'} onSearch={setDisplayRoles} />
							{!!displayRoles.length && (
								<Table titles={columns} data={rows} className={styles.RolesTable} rowClassName={styles.RoleRow} />
							)}
						</section>
					</Page>
				</PageContainer>
				<GlobalAlert />
			</PageAuth>
		</>
	);
};

export { RolesAndPermissions };
